/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseRequest } from '../../models/course-request';

export interface ApiRequestCourseGetRequestByIdGet$Params {
  id?: string;
}

export function apiRequestCourseGetRequestByIdGet(http: HttpClient, rootUrl: string, params?: ApiRequestCourseGetRequestByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseRequest>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCourseGetRequestByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CourseRequest>;
    })
  );
}

apiRequestCourseGetRequestByIdGet.PATH = '/api/Request/Course/GetRequestById';
